import { useState } from "react";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import LightBox, { SlideImage } from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { ImageData, getCategoryImages } from "../imageCollections";
import Title from "./Title";
import Description from "./Description";
import SoldIndicator from "./SoldIndicator";


interface CategoryProps {
  name: string,
}

export default function CategoryView({name}: CategoryProps) {
  const [index, setIndex] = useState(-1);
  const paintings: ImageData[] = getCategoryImages(name);
  if (paintings.length === 0) {
    return <div>Category not found</div>;
  }
  const slides: SlideImage[] = paintings.map((painting) => ({
    src: painting.large || "",
    title: ( <Title painting={painting} /> ),
    description: ( <Description painting={painting} /> ),
  }));
  
  return (
    <div>
      <RowsPhotoAlbum
        photos={paintings}
        rowConstraints={{ maxPhotos: 3 }}
        padding={20}
        render={{
          wrapper: ({ style, ...rest }, { index }) => (
            <div
              onClick={() => setIndex(index)}
              style={{
                ...style,
                borderRadius: "4px",
                boxShadow: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                cursor: "pointer",
              }}
              {...rest}
            />
          ),
        extras: (_, { photo }) => 
          photo.sold ? <SoldIndicator /> : null
        }}
      />
      <LightBox
        slides={slides}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Captions]}
        captions={{
          descriptionTextAlign: "start",
          descriptionMaxLines: 5,
        }}
      />
    </div>
  );
}
